import { Helmet } from 'react-helmet';
import ScrollToTop from '../../../../components/scrollToTop/scrollToTop';
import { useEffect, useState } from 'react';
import { FaEdit, FaTimes } from "react-icons/fa";
import Swal from 'sweetalert2';
import axios from 'axios';
import DeleteExternalDesWarehouses from './delete_external_des_warehouses';

function ExternalDesWarehouses () {
  const [showDeleted, setShowDeleted] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [warehouses, setWarehouses] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [updateTrigger, setUpdateTrigger] = useState(false);

  const filteredData = searchValue
  ? warehouses.filter((data) =>
    (data.name || "").toUpperCase().includes(searchValue.toUpperCase())
  ) : warehouses;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    getWarehouses();
  }, [updateTrigger]);

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const getWarehouses = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        setWarehouses(response.data.data);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  }

  const createWarehouse = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear almacén",
        html:
        '<div class="form-grid">' +
        '<input type="text" id="name" class="swal2-input" placeholder="Nombre del almacén">' +
        '<input type="text" id="arrival" class="swal2-input" placeholder="Destino">' +
        '<input type="text" id="description" class="swal2-input" placeholder="Descripción">' +
        "</div>",
        showDenyButton: true,
        confirmButtonText: "Crear",
        denyButtonText: "Cancelar",
        padding: "1px",
        color: "#000",
        backdrop: `
          rgba(0,0,0,0.8)
        `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },

        preConfirm: async () => {
          const name = document.getElementById("name").value;
          const arrival = document.getElementById("arrival").value;
          const description = document.getElementById("description").value;
  
          if (!name || !arrival || !description) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return;
          }
  
          return {
            name,
            arrival,
            description,
          };
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      if(result.isConfirmed) {
        const userData = result.value;

        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses`;
        const body = {
          "name": userData.name,
          "iata_id": userData.arrival,
          "description": userData.description
        }
        const response = await axios.post(url, body, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        Swal.fire(
          "¡Creado!",
          "El elemento ha sido creado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      }
    } catch (error) {
      console.error('error to warehouse create', error);
      const statusCode = error.response ? error.response.status : null;
      if (statusCode === 404) {
        Swal.fire("Error", "El destino no existe o no se pudo encontrar.", "error");
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  }

  const updateWarehouse = async (warehouse) => {
    try {
      const result = await Swal.fire({
        title: "Actualizar almacén",
        html:
        '<div class="form-grid">' +
        `<input type="text" id="name" class="swal2-input" placeholder="Nombre del almacén" value="${warehouse.name}">` +
        `<input type="text" id="arrival" class="swal2-input" placeholder="Destino" value="${warehouse.iata_id}">` +
        `<input type="text" id="description" class="swal2-input" placeholder="Descripción" value="${warehouse.description}">` +
        "</div>",
        showDenyButton: true,
        confirmButtonText: "Actualizar",
        denyButtonText: "Cancelar",
        padding: "1px",
        color: "#000",
        backdrop: `
          rgba(0,0,0,0.8)
        `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },

        preConfirm: async () => {
          const name = document.getElementById("name").value;
          const arrival = document.getElementById("arrival").value;
          const description = document.getElementById("description").value;
  
          if (!name || !arrival || !description) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }
  
          return {
            name,
            arrival,
            description,
          };
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      if(result.isConfirmed) {
        const userData = result.value;

        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses/${warehouse.id}`;
        const body = {
          "name": userData.name,
          "iata_id": userData.arrival,
          "description": userData.description
        }
        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });

        Swal.fire(
          "¡Actualizado!",
          "El almacén ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      }
    } catch (error) {
      console.error('error to warehouse create', error);
      const statusCode = error.response ? error.response.status : null;
      if (statusCode === 404) {
        Swal.fire("Error", "El destino no existe o no se pudo encontrar.", "error");
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  }

  const deleteWarehouse = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, eliminarlo",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const response = await axios.delete(`${process.env.REACT_APP_URL_BACKEND}/api/v1/external_des_warehouses/${id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });

        Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  return (
    <>
      <Helmet>
        <title>Horus | Almacenes</title>
      </Helmet>
      <ScrollToTop />
      <div className='table-responsive'>
        <div className='dataTables_wrapper dt-bootstrap4 no-footer container-fluid' id='datatables_wrapper'>
            <div className="text-right mb-2">
              <button className="btnn" onClick={() => setShowDeleted(!showDeleted)}>
                {showDeleted ? "Ver Activos" : "Ver Eliminados"}
              </button>
            </div>


            {showDeleted ? (
                <DeleteExternalDesWarehouses setUpdateTrigger={setUpdateTrigger} updateTrigger={updateTrigger} />
            ) : (
                <>
                  <div className="text-right mb-4">
                    <button className="btnn" onClick={createWarehouse} >
                      Añadir Almacenes
                    </button>
                  </div>

                  <div className="row justify-content-between mb-2">
                    <div className="col-sm-12 col-md-4">
                      <div className="dataTables_length mb-2" id="dataTables_length">
                        <label className="d-flex justify-content-start">
                        <span className="mr-2 p-2">Mostrar</span>
                        <select
                          name="datatables_length"
                          aria-controls="datatables_length"
                          className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                          onChange={showEntries}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        <span className="ml-2 p-2">registros</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      <div className="datatables_filter" id="datatables_filter">
                        <label className="d-flex justify-content-end">
                        <input
                          type="search"
                          id="searchInput"
                          className="form-control form-control-sm"
                          placeholder="Buscar..."
                          aria-controls="datatables"
                        />
                        <button className="btnn" onClick={handleSearch}>
                          Buscar
                        </button>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                        role="grid"
                        aria-describedby="datatables_info"
                      >
                        <thead>
                          <tr>
                            <th>
                                Nombre
                            </th>
                            <th>
                                Destino	
                            </th>
                            <th>
                                Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentData.map((warehouse) => (
                            <tr key={warehouse.id} data-master-id={warehouse.id}>
                              <td>{warehouse.name}</td>
                              <td>{warehouse.iata_id}</td>
                              <td>
                                <FaEdit className='editButton' onClick={() => { updateWarehouse(warehouse) }} />
                                <FaTimes className='deleteButton' onClick={() => { deleteWarehouse(warehouse.id) }} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <nav aria-label="Page navigation example">
                      <ul className="pagination">
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Anterior
                          </button>
                        </li>
                        {pageNumbers.map((pageNumber) => (
                        <li className="page-item" key={pageNumber}>
                          <button
                            className="page-link"
                            onClick={() => paginate(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                        ))}
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === pageNumbers.length}
                          >
                            Siguiente
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </>
            )}
        </div>
      </div>
    </>
  )
}


export default ExternalDesWarehouses;